export const styles = (theme) => ({
  clearanceButtonPopup:{
    width:"100%",
    justifyContent: "end",
    padding: "0",
  },
    clearMe: {
      fontSize: "11px",
      borderRadius: "3px",
      background: "#DBBF63",
      color: "#000",
      verticalAlign: "middle",
      padding: "4px 9px",
      "& svg":{
        verticalAlign:"middle",
        marginLeft:"38px",
      },
      width: "115px",
      position:"relative",
    },
    clearanceOverride: {
      padding: "0 15px",
      marginBottom: "8px",
      "& label": {
        fontSize: "12px",
        margin: "8px 0 7px 0",
        display: "block",
        borderTop: "1px solid #676767",
        paddingTop: "10px",
      },
      "& .MuiSelect-select": {
        paddingTop: "4px",
        paddingBottom: "4px",
      },
      "& .MuiInputBase-root":{
        width:"100%",
      }
    },
    clearanceIcon: {
      marginRight: "8px",
      fontSize: "18px",
      "& path":{
        stroke:"#fff",  
      }
    },
  
    clearanceSign: {
      minWidth: "20px",
      height: "20px",
      borderRadius: "50%",
      margin: "5px 10px 5px 0px",
      display: "inline-block",
      verticalAlign: "middle",
    },
    clearanceDropMenu:{
      width:"auto",
      textAlign: "left",
      padding:"0",
      background:"#343434",
      "& .clearanceValueLabel":{
        padding: "0 4px 0 6px",
      }
  
    },
    mainWrap: {
      width: "600px",
    },
    insideLoader:{
      width:"10px !important",
      height:"10px !important",
      color:"#fff",
      marginLeft:"10px",      
    },
 
  });
  